import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, RefreshCwIcon, DropletIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-203">
      <div className="max-w-5xl mx-auto px-4" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-205">
          <div className="text-center mb-12" data-id="element-206">
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436] mb-4" data-id="element-207">
              Cómo Funciona en 3 Pasos
            </h2>
            <p className="text-[#2D3436]/60 max-w-2xl mx-auto" data-id="element-208">
              Un sistema simple que puedes seguir sin importar lo ocupada que
              estés
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-4 relative" data-id="element-209">
            {/* Connecting line (desktop only) */}
            <div className="hidden md:block absolute top-24 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-[#5B8F7B] via-[#C4A962] to-[#5B8F7B]" data-id="element-210"></div>

            {/* Step 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="relative bg-white rounded-2xl p-6 md:p-8 shadow-sm text-center" data-id="element-211">
              <div className="w-16 h-16 bg-[#5B8F7B] rounded-full flex items-center justify-center mx-auto mb-6 relative z-10" data-id="element-212">
                <ZapIcon className="w-8 h-8 text-white" data-id="element-213" />
              </div>
              <div className="absolute top-6 left-6 w-8 h-8 bg-[#C4A962]/20 rounded-full flex items-center justify-center" data-id="element-214">
                <span className="font-['Playfair_Display'] font-bold text-[#C4A962]" data-id="element-215">
                  1
                </span>
              </div>
              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#2D3436] mb-3" data-id="element-216">
                Desactiva
              </h3>
              <p className="text-[#2D3436]/70" data-id="element-217">
                Usas el Vago-Reset antes de tus comidas para calmar el sistema
                digestivo y preparar tu cuerpo para recibir alimentos sin
                inflamarse.
              </p>
            </motion.div>

            {/* Step 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="relative bg-white rounded-2xl p-6 md:p-8 shadow-sm text-center" data-id="element-218">
              <div className="w-16 h-16 bg-[#C4A962] rounded-full flex items-center justify-center mx-auto mb-6 relative z-10" data-id="element-219">
                <RefreshCwIcon className="w-8 h-8 text-white" data-id="element-220" />
              </div>
              <div className="absolute top-6 left-6 w-8 h-8 bg-[#C4A962]/20 rounded-full flex items-center justify-center" data-id="element-221">
                <span className="font-['Playfair_Display'] font-bold text-[#C4A962]" data-id="element-222">
                  2
                </span>
              </div>
              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#2D3436] mb-3" data-id="element-223">
                Sustituye
              </h3>
              <p className="text-[#2D3436]/70" data-id="element-224">
                Cambias los "Alimentos Esponja" por "Alimentos Escudo" durante 7
                días. Sin contar calorías, solo intercambios inteligentes.
              </p>
            </motion.div>

            {/* Step 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="relative bg-white rounded-2xl p-6 md:p-8 shadow-sm text-center" data-id="element-225">
              <div className="w-16 h-16 bg-[#5B8F7B] rounded-full flex items-center justify-center mx-auto mb-6 relative z-10" data-id="element-226">
                <DropletIcon className="w-8 h-8 text-white" data-id="element-227" />
              </div>
              <div className="absolute top-6 left-6 w-8 h-8 bg-[#C4A962]/20 rounded-full flex items-center justify-center" data-id="element-228">
                <span className="font-['Playfair_Display'] font-bold text-[#C4A962]" data-id="element-229">
                  3
                </span>
              </div>
              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#2D3436] mb-3" data-id="element-230">
                Drena
              </h3>
              <p className="text-[#2D3436]/70" data-id="element-231">
                Realizas el ritual nocturno para eliminar el exceso de líquido
                mientras duermes. Despiertas más ligera cada mañana.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}